module.exports = __webpack_public_path__ + "img/derma_logo.894b2c2a.png";